import {Controller} from "@hotwired/stimulus"

//
export default class extends Controller {
    static targets = ["content", "button"]
    static values = {
        activeClass: {type: String, default: "active"},
        inactiveClass: {type: String, default: ""}
    }

    connect() {
        console.log("Button toggler controller connected")
    }

    toggle(event) {
        event.preventDefault()

        let url = event.currentTarget.getAttribute("href")
        this.fetchContent(url)
        this.activateButton(event.currentTarget)
    }

    fetchContent(url) {
        console.log("Fetching content at this URL: ", url)

        fetch(url, {
            credentials: "same-origin"
        })
            .then(response => {
                console.log("Got content", response)
                return response
            })
            .then(response => response.text())
            .then(html => {
                console.log("Adding search results to DOM", html)
                this.contentTarget.innerHTML = html
            })
    }

    activateButton(button) {
        const active = this.activeClassValue.split(" ").filter(Boolean)
        const inactive = this.inactiveClassValue.split(" ").filter(Boolean)

        this.buttonTargets.forEach((element) => {
            const on = element === button
            active.forEach((klass) => element.classList.toggle(klass, on))
            inactive.forEach((klass) => element.classList.toggle(klass, !on))
        })
    }
}
